import { NavLink } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "../../assets/icons";
import {
  ORGANIZATION_SETTINGS_PAGE_TYPES,
  SETTINGS_COMPANY_PAGE_TYPES,
} from "../../constants/settingsPageTypes";
import UseContext from "../../hooks/useContext";
import Button from "../button";
import OrganizationSettingsNavLink from "../settings/OrganizationSettingsNavLink";
import { ROLE_BIG_COMPANY_ADMIN } from "../../constants/roles";
import OrganizationSettingsTabs from "../settings/OrganizationSettingsTabs";
import SettingsTabs from "../settings/SettingsTabs";
import LogoutNavDesktop from "./navbarComponents/LogoutNavDesktop";
import SwitchCompany from "./navbarComponents/SwitchCompany";
const { dateLong, datePeriodLabel } = require("../../utils/Date");

const DAY_MS = 24 * 60 * 60 * 1000;

/** Titre zone gauche de la barre supérieure (unifié sur toutes les pages PageContainer) */
const NAVBAR_TITLE_CLASS = "ft-b font-semibold text-gray-900";

const NavbarSite = ({ type, dateStart, setDateStart, dateEnd, setDateEnd }) => {
  const { companySelected, userData } = UseContext();
  const role =
    userData?.role ??
    (Number(localStorage.getItem("rUser")) || false);
  const canAccessOrganizationSettings =
    role === ROLE_BIG_COMPANY_ADMIN;
  const periodDays =
    dateStart && dateEnd
      ? Math.round((new Date(dateEnd) - new Date(dateStart)) / DAY_MS) + 1
      : 1;

  const onPrevPeriod = () => {
    if (!dateStart || !dateEnd) return;
    const shiftMs = periodDays * DAY_MS;
    setDateStart(new Date(dateStart.getTime() - shiftMs));
    setDateEnd(new Date(dateEnd.getTime() - shiftMs));
  };

  const onNextPeriod = () => {
    if (!dateStart || !dateEnd) return;
    const shiftMs = periodDays * DAY_MS;
    setDateStart(new Date(dateStart.getTime() + shiftMs));
    setDateEnd(new Date(dateEnd.getTime() + shiftMs));
  };

  if (ORGANIZATION_SETTINGS_PAGE_TYPES.has(type)) {
    return (
      <header className="shrink-0 border-b border-b-gray-100">
        <div className="flex justify-between items-center px-[20px] py-4">
          <div className="flex min-w-0 flex-1 items-center gap-3 sm:gap-4">
            <NavLink
              to="/settings/sectors"
              aria-label="Retour aux paramètres de l’entreprise"
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-gray-100 bg-white text-gray-700 no-underline transition-colors hover:bg-gray-100 active:bg-gray-200"
            >
              <ChevronLeft wh={18} color="#374151" aria-hidden />
            </NavLink>
            <div
              className={`${NAVBAR_TITLE_CLASS} min-w-0 truncate`}
            >
              Paramètres de l'organisation
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="h-[50px] w-[210px]" aria-hidden />
            <LogoutNavDesktop />
          </div>
        </div>
        <div
          className="px-4 py-4 sm:px-[20px]"
          aria-label="Sous-navigation paramètres organisation"
        >
          <OrganizationSettingsTabs />
        </div>
      </header>
    );
  }

  if (SETTINGS_COMPANY_PAGE_TYPES.has(type)) {
    return (
      <header className="shrink-0 border-b border-b-gray-100">
        <div className="flex justify-between items-center px-[20px] py-4">
          <div className={NAVBAR_TITLE_CLASS}>
            {companySelected?.name
              ? `Paramètres de ${companySelected.name}`
              : "Paramètres"}
          </div>
          <div className="flex items-center gap-3">
            <SwitchCompany />
            <LogoutNavDesktop />
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-[20px]">
          <SettingsTabs />
          {canAccessOrganizationSettings ? (
            <OrganizationSettingsNavLink />
          ) : null}
        </div>
      </header>
    );
  }

  return (
    <nav
      className={`py-4 px-[20px]`}
    >
      <div className={"flex justify-between items-center"}>
        <div className={"capitalize"}>
          {type === "hourly_tracking" ? (
            <div className={"flex gap-2.5 items-center"}>
              <div className={"flex gap-1"}>
                <Button
                  color={"SECONDARY"}
                  size={"SMI"}
                  onClick={onPrevPeriod}
                  name={"header_hourly_tracking_prev_date"}
                >
                  <ChevronLeft wh={16} color={"#374151"} />
                </Button>
                <Button
                  color={"SECONDARY"}
                  size={"SMI"}
                  onClick={onNextPeriod}
                  name={"header_hourly_tracking_next_date"}
                >
                  <ChevronRight wh={16} color={"#374151"} />
                </Button>
              </div>
              <div
                className={`${NAVBAR_TITLE_CLASS} header_hourly_tracking_date_display`}
              >
                {datePeriodLabel(dateStart, dateEnd)}
              </div>
            </div>
          ) : type === "activity" ? (
            <div className={NAVBAR_TITLE_CLASS}>Activité</div>
          ) : type === "employees" ? (
            <div className={NAVBAR_TITLE_CLASS}>Employés</div>
          ) : (
            <span className={NAVBAR_TITLE_CLASS}>{dateLong(new Date())}</span>
          )}
        </div>
        <div className="flex items-center gap-3">
          <SwitchCompany />
          <LogoutNavDesktop />
        </div>
      </div>
    </nav>
  );
};

export default NavbarSite;
